import React from "react";
import "./MetricCard.css";

/**
 * MetricCard – modern dashboard KPI card.
 * - tone: "neutral" | "success" | "error" | "warning" | "info"
 * - icon: optional ReactNode rendered in the small icon chip
 * - sparkline: optional ReactNode (e.g. <Sparkline />)
 * - footer: optional ReactNode
 */
export default function MetricCard({
  label,
  value,
  unit,
  delta,
  tone = "neutral",
  icon,
  sparkline,
  footer,
  accent,
  className = "",
}) {
  return (
    <div className={`metric-card metric-card--${tone} ${className}`} data-accent={accent}>
      <div className="metric-card__top">
        <div className="metric-card__heading">
          <span className="metric-card__label">{label}</span>
          {icon && (
            <span className="metric-card__icon">{icon}</span>
          )}
        </div>

        <div className="metric-card__value-row">
          <span className="metric-card__value">{value}</span>
          {unit && <span className="metric-card__unit">{unit}</span>}
        </div>

        {delta && (
          <span className={`metric-card__delta metric-card__delta--${tone}`}>
            {delta}
          </span>
        )}
      </div>

      {sparkline && (
        <div className="metric-card__sparkline">
          {sparkline}
        </div>
      )}

      {footer && (
        <div className="metric-card__footer">
          {footer}
        </div>
      )}
    </div>
  );
}
